module.exports = __webpack_public_path__ + "static/media/oportunidades_card_detail.a41d5908.png";